
import React from "react";

import Button from "../../../../core/Button";
import Input from "../../../../core/Inputs/DefaultInput";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";

import Axios from "axios";
// routes
import { Link } from "react-router-dom";
import { GoogleLogin } from '@react-oauth/google';
import { useGoogleLogin } from '@react-oauth/google';
import PasswordChecklist from "react-password-checklist"

import Svg from "../../../../component/common/Svg";

import { elementIsOrContains } from "@blueprintjs/core/lib/esm/common/utils";

// const emailRegex =/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const SignUp = () => {

  // let urlHead = {process.env.NODE_API_URL_HEADER};
  // alert(urlHead);
  let device = useDevice();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const errRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);

  const [email, setEmail] = useState('')
  const [validEmail, setValidEmail] = useState(false)
  const [blankEmail, setBlankEmail] = useState(0)
  const [emailError, setEmailError] = useState('')
  const [emailSuccessMsg, setEmailSuccessMsg] = useState('')

  const [password, setPassword] = useState('')
  const [validPassword, setValidPassword] = useState(false)
  const [blankPassword, setBlankPassword] = useState(0)
  const [passwordError, setPasswordError] = useState(0)
  const [passwordSuccessMsg, setPasswordSuccessMsg] = useState('')

  const [passwordType, setPasswordType] = useState('password');
  const [passwordValidateFlag, setPasswordValidateFlag] = useState(0);

  const [hidePasswordChecklist, setHidePasswordChecklist] = useState(true);



  useEffect(() => {
    setValidEmail(emailRegex.test(email));
    handleFormSubmit();
  }, [email])


  useEffect(() => {
    setValidPassword(passwordValidateFlag === 1);
    handlePasswordSubmit();
  }, [password])


  const handleEmailChange = (e) => {
    setEmailError('');
    setEmailSuccessMsg('');
    setEmail(e.target.value);
  }

  const handlePasswordChange = (e) => {
    setPasswordError('');
    setPasswordSuccessMsg('');
    setPassword(e.target.value);
  }

  const handleFormSubmit = (e) => {

    if (email !== '') {

      if (emailRegex.test(email)) {
        setEmailSuccessMsg(' ');
      }
      else {
        setEmailError('This is not a valid email')
      }
    }
    else {
      setEmailError('Email is Required');
    }
  }

  const handlePasswordSubmit = (e) => {
    if (password !== '') {
      if (passwordValidateFlag === 1) {
        setPasswordSuccessMsg(' ');
      }
      else {
        setPasswordError('The password does not meet the password requirements');
      }
    }
    else {
      setPasswordError('Password is Required');
    }
  }

  function validatePassword(isValid) {
    // alert(isValid);
    if (password.length !== 0 && isValid) {
      setPasswordValidateFlag(1);
    } else if (password.length !== 0) {
      setPasswordValidateFlag(0);
      setPasswordError('The password does not meet the password requirements');
    }

  }

  useEffect(() => {
    const str = String(inputRef?.current?.props.value)?.length;
    setCount(str);
  }, []);


  function viewPassword(e) {
    if (passwordType == "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }

  }

  const handleCount = e => {
    setCount(String(e.target.value).length);
  };

  const handleFailure = (result) => {
    alert(Object.values(result));
  };

  const responseGoogleSuccess = (credentialResponse) => {
    const signUpData = (parseJwt(credentialResponse.credential));
    //console.log(signUpData);

    if (signUpData.email_verified === true) {
      Axios.post(process.env.REACT_APP_NODE_API_URL + "/users/googlesignUp", {
        name: signUpData.given_name,
        email: signUpData.email,
        gl_profile_image: signUpData.picture,
        gl_client_id: signUpData.sub,
      }).then((response) => {
        if (response.data.response == 200) {
          alert("Signup Successful!");
          window.location = '/AccountSetUpGl/?email=' + signUpData.email;
        } else {
          alert("Unable to sign up, Invalid Credentials");
        }
      });

    }
  }

  const responseGoogleFail = (credentialResponse) => {
    alert("Google Login Failed, Try Again");
  }

  function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };



  //posting Login Details
  const submitSignup = () => {

    if ((email !== "" && password !== "")) {

      handleFormSubmit();
      handlePasswordSubmit();
      if ((emailRegex.test(email) === true) && (passwordValidateFlag === 1)) {
        //Verifying if user is already present in Databases
        Axios.post(process.env.REACT_APP_NODE_API_URL + "/users/getUserDetails", {
          email: email,
        }).then((response) => {
          if (response.data.response == 200) {
            alert("user already present, please login or reset password");
            //window.location = '/EmailVerification/?email=' + email;
          } else {
            //creating user
            Axios.post(process.env.REACT_APP_NODE_API_URL + "/users/signUp", {
              email: email,
              password: password,
            }).then((response) => {

              if (response.data.response == 200) {
                alert("Signup Successful!");
                window.location = '/EmailVerification/?email=' + email;
              } else {
                alert("Unable to sign up..");
              }
            });
          }
        });
      }
      else {
        alert("Unable to sign up..");
      }

    } else {

      if (email === "") {
        setBlankEmail(1);
        setEmailError('Email is Required');
      } if(password === "") {
        setBlankPassword(1);
        setPasswordError('Password is Required');
      }

    }

  };

  return (
    <>
      <div className='d-flex flex-column site-main-wrapper login-page'>
        <div className="flex-grow-1 main-content-wrap d-flex align-items-center justify-content-center">
          <div className="container">
            <div className="form-outer-wrapper">
              <div className="logo-wrap text-center">
                <Link to="/#0t" className='home-logo'>
                  <Svg name="logo" />
                </Link>
              </div>
              <div className="form-wrapper mb__20">
                <div className="form-heading text-center">
                  <h3>Log in or sign up in seconds</h3>
                  <p>Use your work email to log in or get started</p>
                </div>
                <form >
                  <div className="field-wrapper">
                    <div className="mb__20 position-relative"> {/* Add Class error to this div once error occurs and if its valid, add class success*/}

                      {

                        (email.length > 0 || blankEmail == 1 ) ?
                          <>

                            <div className={(validEmail) ? "success" : "validation-msg"} >
                              {(validEmail) ? '' : emailError}
                            </div>
                          </>

                          : ''
                      }

                      < Input
                        ref={inputRef}
                        type='text'
                        view='outlined'
                        dense={false}
                        color='default'
                        label=''
                        placeholder='Email'
                        clearButton={true}
                        success={false}
                        error={false}
                        fill={true}
                        errorHelperText={null}
                        className={"formsinput"}
                        value={email}
                        name="email"
                        onInput={handleEmailChange}
                        aria-invalid={validEmail ? "false" : "true"}
                      />


                    </div>

                    <div className="mb__20 position-relative"> {/* Add class focus once we are writing in the field */}

                      {
                        (password.length > 0 || blankPassword == 1 ) ?
                          <>
                            <div className={(validPassword) ? "success" : "validation-msg"} >
                              {(validPassword) ? '' : passwordError}
                            </div>
                          </>

                          : ''
                      }
                      
                      <Input
                        type={passwordType}
                        view="outlined"
                        color="default"
                        label=""
                        placeholder="Password"
                        fill
                        className={"formsinput"}
                        name="password"
                        value={password}
                        onInput={handlePasswordChange}
                        onChange={() => setHidePasswordChecklist(false)}
                        aria-invalid={validPassword ? "false" : "true"}
                      />


                      <PasswordChecklist
                        rules={["minLength", "specialChar",
                          "number", "capital"]}
                        minLength={6}
                        value={password}
                        onChange={(isValid) => { validatePassword(isValid) }}
                        iconSize={14}
                        invalidColor="#F05454"
                        validColor="#1d4328"
                        messages={{
                          minLength: "Minimum of 6 characters",
                          capital: "Contains an uppercase letter",
                          number: "Contains a number (0-9)",
                          specialChar: "Contains special characters (!@#$%&*.)",
                        }}
                        className={` ${hidePasswordChecklist ? "hide-checklist" : ""}`}

                      />


                      {/* <div className="password-requirement">
                        <p>Requirements</p>
                        <ul>
                          <li className="invalid">Minimum of 6 characters</li>
                          <li className="invalid">Contains an uppercase letter</li>
                          <li className="valid">Contains a number (0-9)</li>
                          <li className="valid">Contains special characters (!@#$%&*.)</li>
                        </ul>
                      </div> */}
                      <span className={"forgot-wrap " + passwordType} onClick={viewPassword}>
                        <i className="fa fa-eye" aria-hidden="true"></i>
                      </span>

                    </div>
                    {/* <Link to="/EmailVerification"> */}
                  </div>
                  <div className="button-wrap">
                    <Button className={"formsbutton"}
                      type="default"
                      view="filled"
                      color="primary"
                      text="Create account"
                      fill={true}
                      // onClick={() => setOpen(true)}
                      onClick={submitSignup}
                    />

                    {/* </Link> */}


                    {/* <Button
                    className={"googlebutton"}
                    type="default"
                    view="outlined"
                    color="default"
                    text="Sign-Up with Google"
                    icon={<img src={Google} alt="" />}
                    style={{ color: "#000", boxShadow: "0 0 0 1px #C1C7CF" }}
                    // onClick={() => setOpen(true)}
                    clearButton
                    fill 
                    onClick={() => googleLogin()}>
                    </Button> */}
                    <div className="google-btn">
                      <GoogleLogin
                        onSuccess={responseGoogleSuccess}
                        onFailure={responseGoogleFail}
                      />
                    </div>
                  </div>
                </form>
                <div className="form-text text-center">
                  <p>Already a member? <Link to="/">Login here</Link></p>
                </div>
              </div>
              <div className="outer-form-text text-center">
                <p>By continuing, you agree to Survey Tool <Link to="">Terms of Use</Link> Read our <Link to="">Privacy Policy</Link></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
